import { render } from "./Corporate.vue?vue&type=template&id=cf0aea4a&scoped=true"
import script from "./Corporate.vue?vue&type=script&lang=js"
export * from "./Corporate.vue?vue&type=script&lang=js"

import "./Corporate.vue?vue&type=style&index=0&id=cf0aea4a&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf0aea4a"]])

export default __exports__